<div class="gm-gallery">
  <div class="gm-hero">
    <div class="gm-hero-eyebrow">Voyager Arcade</div>
    <h2 class="gm-hero-title">Games</h2>
    <p class="gm-hero-sub">Seven ways to unwind between bookings. Pick one — it opens in its own floating panel you can drag anywhere.</p>
  </div>
  <div class="gm-grid">
    @for (g of games; track g.id) {
      <button class="gm-card" [style.--g-accent]="g.accent" (click)="play.emit(g)">
        <div class="gm-card-art" [style.background]="g.gradient">
          <div class="gm-card-artinner">
            @switch (g.art) {
              @case ('num') {
                <svg viewBox="0 0 120 80" class="ga-svg">
                  @for (t of numTop; track t.cx) {
                    <g><circle [attr.cx]="t.cx" cy="26" r="11" fill="rgba(255,255,255,.14)" stroke="rgba(255,255,255,.45)"/><text [attr.x]="t.cx" y="31" text-anchor="middle" font-size="13" font-weight="800" fill="#fff">{{ t.v }}</text></g>
                  }
                  <circle cx="20" cy="54" r="11" fill="rgba(255,255,255,.92)"/><text x="20" y="59" text-anchor="middle" font-size="13" font-weight="800" fill="#c2410c">3</text>
                  <circle cx="92" cy="54" r="11" fill="rgba(255,255,255,.92)"/><text x="92" y="59" text-anchor="middle" font-size="13" font-weight="800" fill="#c2410c">7</text>
                  <path d="M20 65v6h72v-6" fill="none" stroke="rgba(255,255,255,.7)" stroke-width="1.6"/>
                  <text x="56" y="58" text-anchor="middle" font-size="11" font-weight="700" fill="rgba(255,255,255,.85)">=10</text>
                </svg>
              }
              @case ('nm') {
                <svg viewBox="0 0 120 80" class="ga-svg">
                  @for (i of [0,1,2,3]; track i) { <rect [attr.x]="10 + i * 26" y="18" width="20" height="28" rx="4" fill="rgba(255,255,255,.16)" stroke="rgba(255,255,255,.5)"/> }
                  <rect x="36" y="18" width="20" height="28" rx="4" fill="rgba(255,255,255,.92)"/><text x="46" y="37" text-anchor="middle" font-size="16" font-weight="800" fill="#6d28d9">7</text>
                  <rect x="62" y="18" width="20" height="28" rx="4" fill="rgba(255,255,255,.92)"/><text x="72" y="37" text-anchor="middle" font-size="16" font-weight="800" fill="#6d28d9">7</text>
                  <text x="20" y="37" text-anchor="middle" font-size="15" fill="rgba(255,255,255,.6)">?</text>
                  <text x="98" y="37" text-anchor="middle" font-size="15" fill="rgba(255,255,255,.6)">?</text>
                </svg>
              }
              @case ('ms') {
                <svg viewBox="0 0 120 80" class="ga-svg">
                  @for (m of msRects; track $index) { <rect [attr.x]="m.x" [attr.y]="m.y" width="15" height="13" rx="2.5" fill="rgba(255,255,255,.14)" stroke="rgba(255,255,255,.35)"/> }
                  <rect x="37" y="27" width="15" height="13" rx="2.5" fill="rgba(255,255,255,.9)"/><text x="44.5" y="37" text-anchor="middle" font-size="10" font-weight="800" fill="#0369a1">3</text>
                  <circle cx="79.5" cy="48.5" r="5" fill="#0b1220"/><path d="M79.5 42v13M73 48.5h13" stroke="#0b1220" stroke-width="1.6"/>
                  <text x="61.5" y="20.5" text-anchor="middle" font-size="10">🚩</text>
                </svg>
              }
              @case ('tf') {
                <svg viewBox="0 0 120 80" class="ga-svg">
                  <rect x="30" y="8" width="60" height="60" rx="8" fill="rgba(255,255,255,.12)"/>
                  <g><rect x="38" y="16" width="20" height="20" rx="4" fill="#f0e6d8"/><text x="48" y="30" text-anchor="middle" font-size="10" font-weight="800" fill="#6b5b45">2</text></g>
                  <g><rect x="62" y="16" width="20" height="20" rx="4" fill="#f5b06a"/><text x="72" y="30" text-anchor="middle" font-size="10" font-weight="800" fill="#fff">8</text></g>
                  <g><rect x="38" y="40" width="20" height="20" rx="4" fill="#efc949"/><text x="48" y="54" text-anchor="middle" font-size="6.5" font-weight="800" fill="#fff">128</text></g>
                  <g><rect x="62" y="40" width="20" height="20" rx="4" fill="#efa50f"/><text x="72" y="54" text-anchor="middle" font-size="6.5" font-weight="800" fill="#fff">2048</text></g>
                </svg>
              }
              @case ('sd') {
                <svg viewBox="0 0 120 80" class="ga-svg">
                  <rect x="38" y="8" width="44" height="44" rx="4" fill="rgba(255,255,255,.1)" stroke="rgba(255,255,255,.5)"/>
                  @for (i of [1,2]; track i) { <line [attr.x1]="38 + i * 14.67" y1="8" [attr.x2]="38 + i * 14.67" y2="52" stroke="rgba(255,255,255,.5)"/> }
                  @for (i of [1,2]; track i) { <line x1="38" [attr.y1]="8 + i * 14.67" x2="82" [attr.y2]="8 + i * 14.67" stroke="rgba(255,255,255,.5)"/> }
                  <text x="43" y="20" text-anchor="middle" font-size="11" font-weight="700" fill="rgba(255,255,255,.95)">5</text>
                  <text x="72" y="20" text-anchor="middle" font-size="11" font-weight="700" fill="rgba(255,255,255,.95)">3</text>
                  <text x="57" y="35" text-anchor="middle" font-size="11" font-weight="700" fill="rgba(255,255,255,.95)">8</text>
                  <text x="43" y="49" text-anchor="middle" font-size="11" font-weight="700" fill="rgba(255,255,255,.95)">1</text>
                  <text x="72" y="49" text-anchor="middle" font-size="11" font-weight="700" fill="rgba(255,255,255,.95)">9</text>
                </svg>
              }
              @case ('ch') {
                <svg viewBox="0 0 120 80" class="ga-svg">
                  @for (m of chRects; track $index) { <rect [attr.x]="m.x" [attr.y]="m.y" width="12" height="12" [attr.fill]="m.dark ? 'rgba(255,255,255,.14)' : 'rgba(255,255,255,.42)'"/> }
                  <text x="44" y="23" text-anchor="middle" font-size="13" fill="#0b1220">♞</text>
                  <text x="80" y="59" text-anchor="middle" font-size="13" fill="#fff">♚</text>
                  <text x="68" y="35" text-anchor="middle" font-size="13" fill="#0b1220">♟</text>
                </svg>
              }
              @case ('c4') {
                <svg viewBox="0 0 120 80" class="ga-svg">
                  <rect x="34" y="10" width="52" height="60" rx="7" fill="rgba(255,255,255,.16)"/>
                  @for (m of c4Circles; track $index) { <circle [attr.cx]="m.cx" [attr.cy]="m.cy" r="4.2" fill="rgba(11,18,32,.55)"/> }
                  <circle cx="55" cy="52" r="4.2" fill="#ef4444"/><circle cx="55" cy="41" r="4.2" fill="#ef4444"/><circle cx="66" cy="52" r="4.2" fill="#facc15"/>
                </svg>
              }
            }
          </div>
          <span class="gm-card-play"><svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor"><path d="M4 2.5v11l9-5.5z"/></svg> Play</span>
        </div>
        <div class="gm-card-meta">
          <span class="gm-card-name">{{ g.name }}</span>
          <span class="gm-card-tag">{{ g.tag }}</span>
        </div>
      </button>
    }
  </div>
</div>
